import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { generateQueryParams } from "../../lib/utils";

const initialState = {
  page: 0,
  rowsPerPage: 10,
  totalRequests: 0,
  data: [],
  filters: {},
  loading: false,
  error: null,
};

const UpdateBalanceSlice = createSlice({
  name: "updatebalance",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload.requests;
      state.totalRequests = action.payload.totalRequests;
      state.loading = false;
      state.error = null;
    },
    setRecord: (state, action) => {
      const index = state.data.findIndex((d) => d._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    },
  },
});

// Actions
export const {
  requestStart,
  ApiSuccess,
  requestFailure,
  setFilters,
  setPage,
  setRowsPerPage,
  setRecord,
} = UpdateBalanceSlice.actions;

export const GetRefreshBalance = (page, limit, filters) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.get(
      `/private/backend/refreshbal?${generateQueryParams({
        ...filters,
        page,
        limit,
      })}`
    );
    dispatch(ApiSuccess(response.data));
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export const UpdateBalance = (data) => async (dispatch) => {
  try {
    // dispatch(requestStart());
    const response = await axios.post(`/private/backend/refreshbal`, data);
    dispatch(ApiSuccess(response.data));
    toast.success("Balance Updated Successfully");
  } catch (err) {
    dispatch(GetRefreshBalance());

    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    // dispatch(
    //   requestFailure(err?.response?.data?.message || "Something went wrong!")
    // );
  }
};
export const UpdateBalances = (data) => async (dispatch) => {
  try {
    const response = await axios.put(`/private/backend/refreshbal`, data);
    dispatch(setRecord(response.data));
    toast.success("Balance Updated Successfully");
    return null;
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    return null;
  }
};

export default UpdateBalanceSlice.reducer;
